<template>
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Activity type</th>
          <th>Activity</th>
          <th>Time</th>
          <th>Minutes</th>
          <th>Intensity</th>
        </tr>
      </thead>
      <transition-group tag="tbody" name="fade">
        <tr v-for="item in entry" :key="item.id">
          <td>{{ item.data.activityType }}</td>
          <td>{{ item.data.activity }}</td>
          <td>{{ item.data.activityTime }}</td>
          <td>{{ item.data.activityMinutes }}</td>
          <td>{{ item.data.activityIntensity }}</td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "Table",
  props: ["entry"]
};
</script>
